export const getMinimunScrollerQuantity = (width) => {
  if(window.innerWidth > 1081) return 4 
  return 3
} 